export interface UserInfo {
	id: string;
	email: string;
	name?: string;
	username?: string;
	firstName?: string;
	lastName?: string;
	school?: string;
	gradYear?: number;
	examDate?: string;
	profession?: string;
	specialities?: string[];
	country?: string;
	onboarding?: {
		status: "in_progress" | "completed";
		startedAt?: string | null;
		completedAt?: string | null;
		profile?: {
			username?: string;
			first_name?: string;
			last_name?: string;
			learner_type_id?: string;
			target_level_id?: string;
			skill_ids?: string[];
			plan_id?: string;
			exam_id?: string;
			category_id?: string;
			level_id?: string;
			state_code?: string;
		};
	};
}

export type AchievementType = {
	title: string;
	description: string;
	points: number;
	level: number;
	events: number;
	totalEvents: number;
	usersEarned: number;
	icon: {
		url: string;
		backgroundColor: string;
	};
};
